import { HistoricalOccupancy } from 'types/CarTracking';

type OccupancySeries = Array<{
    time: string;
    today: number | null;
    pastAvg: number | null;
}>;

function buildDatapoints(series: OccupancySeries): HistoricalOccupancy['datapoints'] {
    return series.reduce<HistoricalOccupancy['datapoints']>((result, item) => {
        result[item.time] = {
            today_occupancy: item.today,
            past_avg_occupancy: item.pastAvg,
        };
        return result;
    }, {});
}

const fullDatapoints: HistoricalOccupancy['datapoints'] = {
    '00:00': { today_occupancy: 13, past_avg_occupancy: 10 },
    '00:10': { today_occupancy: 13, past_avg_occupancy: 8 },
    '00:20': { today_occupancy: 13, past_avg_occupancy: 8 },
    '00:30': { today_occupancy: 14, past_avg_occupancy: 8 },
    '00:40': { today_occupancy: 14, past_avg_occupancy: 8 },
    '00:50': { today_occupancy: 13, past_avg_occupancy: 7 },
    '01:00': { today_occupancy: 13, past_avg_occupancy: 8 },
    '01:10': { today_occupancy: 10, past_avg_occupancy: 7 },
    '01:20': { today_occupancy: 10, past_avg_occupancy: 7 },
    '01:30': { today_occupancy: 10, past_avg_occupancy: 7 },
    '01:40': { today_occupancy: 10, past_avg_occupancy: 8 },
    '01:50': { today_occupancy: 10, past_avg_occupancy: 7 },
    '02:00': { today_occupancy: 10, past_avg_occupancy: 8 },
    '02:10': { today_occupancy: 9, past_avg_occupancy: 6 },
    '02:20': { today_occupancy: 9, past_avg_occupancy: 6 },
    '02:30': { today_occupancy: 10, past_avg_occupancy: 6 },
    '02:40': { today_occupancy: 10, past_avg_occupancy: 6 },
    '02:50': { today_occupancy: 8, past_avg_occupancy: 7 },
    '03:00': { today_occupancy: 8, past_avg_occupancy: 6 },
    '03:10': { today_occupancy: 8, past_avg_occupancy: 6 },
    '03:20': { today_occupancy: 8, past_avg_occupancy: 6 },
    '03:30': { today_occupancy: 9, past_avg_occupancy: 6 },
    '03:40': { today_occupancy: 9, past_avg_occupancy: 5 },
    '03:50': { today_occupancy: 9, past_avg_occupancy: 6 },
    '04:00': { today_occupancy: 9, past_avg_occupancy: 6 },
    '04:10': { today_occupancy: 8, past_avg_occupancy: 6 },
    '04:20': { today_occupancy: 8, past_avg_occupancy: 6 },
    '04:30': { today_occupancy: 9, past_avg_occupancy: 6 },
    '04:40': { today_occupancy: 9, past_avg_occupancy: 6 },
    '04:50': { today_occupancy: 9, past_avg_occupancy: 7 },
    '05:00': { today_occupancy: 9, past_avg_occupancy: 7 },
    '05:10': { today_occupancy: 12, past_avg_occupancy: 8 },
    '05:20': { today_occupancy: 12, past_avg_occupancy: 8 },
    '05:30': { today_occupancy: 18, past_avg_occupancy: 12 },
    '05:40': { today_occupancy: 17, past_avg_occupancy: 12 },
    '05:50': { today_occupancy: 19, past_avg_occupancy: 15 },
    '06:00': { today_occupancy: 25, past_avg_occupancy: 18 },
    '06:10': { today_occupancy: 25, past_avg_occupancy: 21 },
    '06:20': { today_occupancy: 26, past_avg_occupancy: 24 },
    '06:30': { today_occupancy: 31, past_avg_occupancy: 32 },
    '06:40': { today_occupancy: 49, past_avg_occupancy: 37 },
    '06:50': { today_occupancy: 72, past_avg_occupancy: 50 },
    '07:00': { today_occupancy: 92, past_avg_occupancy: 61 },
    '07:10': { today_occupancy: 96, past_avg_occupancy: 71 },
    '07:20': { today_occupancy: 117, past_avg_occupancy: 79 },
    '07:30': { today_occupancy: 108, past_avg_occupancy: 84 },
    '07:40': { today_occupancy: 111, past_avg_occupancy: 87 },
    '07:50': { today_occupancy: 112, past_avg_occupancy: 92 },
    '08:00': { today_occupancy: 111, past_avg_occupancy: 97 },
    '08:10': { today_occupancy: 112, past_avg_occupancy: 102 },
    '08:20': { today_occupancy: 117, past_avg_occupancy: 103 },
    '08:30': { today_occupancy: 115, past_avg_occupancy: 107 },
    '08:40': { today_occupancy: 115, past_avg_occupancy: 106 },
    '08:50': { today_occupancy: 114, past_avg_occupancy: 112 },
    '09:00': { today_occupancy: 115, past_avg_occupancy: 112 },
    '09:10': { today_occupancy: 115, past_avg_occupancy: 111 },
    '09:20': { today_occupancy: 121, past_avg_occupancy: 116 },
    '09:30': { today_occupancy: 113, past_avg_occupancy: 115 },
    '09:40': { today_occupancy: 123, past_avg_occupancy: 116 },
    '09:50': { today_occupancy: 122, past_avg_occupancy: 116 },
    '10:00': { today_occupancy: 118, past_avg_occupancy: 116 },
    '10:10': { today_occupancy: 121, past_avg_occupancy: 114 },
    '10:20': { today_occupancy: 119, past_avg_occupancy: 113 },
    '10:30': { today_occupancy: 119, past_avg_occupancy: 115 },
    '10:40': { today_occupancy: 120, past_avg_occupancy: 115 },
    '10:50': { today_occupancy: 120, past_avg_occupancy: 115 },
    '11:00': { today_occupancy: 126, past_avg_occupancy: 115 },
    '11:10': { today_occupancy: 119, past_avg_occupancy: 119 },
    '11:20': { today_occupancy: 123, past_avg_occupancy: 115 },
    '11:30': { today_occupancy: 0, past_avg_occupancy: 115 },
    '11:40': { today_occupancy: null, past_avg_occupancy: 115 },
    '11:50': { today_occupancy: null, past_avg_occupancy: 119 },
    '12:00': { today_occupancy: null, past_avg_occupancy: 117 },
    '12:10': { today_occupancy: null, past_avg_occupancy: 117 },
    '12:20': { today_occupancy: null, past_avg_occupancy: 113 },
    '12:30': { today_occupancy: null, past_avg_occupancy: 115 },
    '12:40': { today_occupancy: null, past_avg_occupancy: 118 },
    '12:50': { today_occupancy: null, past_avg_occupancy: 115 },
    '13:00': { today_occupancy: null, past_avg_occupancy: 114 },
    '13:10': { today_occupancy: null, past_avg_occupancy: 114 },
    '13:20': { today_occupancy: null, past_avg_occupancy: 116 },
    '13:30': { today_occupancy: null, past_avg_occupancy: 114 },
    '13:40': { today_occupancy: null, past_avg_occupancy: 116 },
    '13:50': { today_occupancy: null, past_avg_occupancy: 115 },
    '14:00': { today_occupancy: null, past_avg_occupancy: 113 },
    '14:10': { today_occupancy: null, past_avg_occupancy: 112 },
    '14:20': { today_occupancy: null, past_avg_occupancy: 114 },
    '14:30': { today_occupancy: null, past_avg_occupancy: 113 },
    '14:40': { today_occupancy: null, past_avg_occupancy: 113 },
    '14:50': { today_occupancy: null, past_avg_occupancy: 114 },
    '15:00': { today_occupancy: null, past_avg_occupancy: 112 },
    '15:10': { today_occupancy: null, past_avg_occupancy: 111 },
    '15:20': { today_occupancy: null, past_avg_occupancy: 111 },
    '15:30': { today_occupancy: null, past_avg_occupancy: 111 },
    '15:40': { today_occupancy: null, past_avg_occupancy: 109 },
    '15:50': { today_occupancy: null, past_avg_occupancy: 110 },
    '16:00': { today_occupancy: null, past_avg_occupancy: 109 },
    '16:10': { today_occupancy: null, past_avg_occupancy: 107 },
    '16:20': { today_occupancy: null, past_avg_occupancy: 102 },
    '16:30': { today_occupancy: null, past_avg_occupancy: 102 },
    '16:40': { today_occupancy: null, past_avg_occupancy: 97 },
    '16:50': { today_occupancy: null, past_avg_occupancy: 93 },
    '17:00': { today_occupancy: null, past_avg_occupancy: 89 },
    '17:10': { today_occupancy: null, past_avg_occupancy: 86 },
    '17:20': { today_occupancy: null, past_avg_occupancy: 80 },
    '17:30': { today_occupancy: null, past_avg_occupancy: 80 },
    '17:40': { today_occupancy: null, past_avg_occupancy: 74 },
    '17:50': { today_occupancy: null, past_avg_occupancy: 73 },
    '18:00': { today_occupancy: null, past_avg_occupancy: 70 },
    '18:10': { today_occupancy: null, past_avg_occupancy: 67 },
    '18:20': { today_occupancy: null, past_avg_occupancy: 64 },
    '18:30': { today_occupancy: null, past_avg_occupancy: 60 },
    '18:40': { today_occupancy: null, past_avg_occupancy: 56 },
    '18:50': { today_occupancy: null, past_avg_occupancy: 56 },
    '19:00': { today_occupancy: null, past_avg_occupancy: 55 },
    '19:10': { today_occupancy: null, past_avg_occupancy: 52 },
    '19:20': { today_occupancy: null, past_avg_occupancy: 53 },
    '19:30': { today_occupancy: null, past_avg_occupancy: 48 },
    '19:40': { today_occupancy: null, past_avg_occupancy: 39 },
    '19:50': { today_occupancy: null, past_avg_occupancy: 34 },
    '20:00': { today_occupancy: null, past_avg_occupancy: 29 },
    '20:10': { today_occupancy: null, past_avg_occupancy: 24 },
    '20:20': { today_occupancy: null, past_avg_occupancy: 23 },
    '20:30': { today_occupancy: null, past_avg_occupancy: 19 },
    '20:40': { today_occupancy: null, past_avg_occupancy: 18 },
    '20:50': { today_occupancy: null, past_avg_occupancy: 17 },
    '21:00': { today_occupancy: null, past_avg_occupancy: 16 },
    '21:10': { today_occupancy: null, past_avg_occupancy: 16 },
    '21:20': { today_occupancy: null, past_avg_occupancy: 14 },
    '21:30': { today_occupancy: null, past_avg_occupancy: 13 },
    '21:40': { today_occupancy: null, past_avg_occupancy: 14 },
    '21:50': { today_occupancy: null, past_avg_occupancy: 14 },
    '22:00': { today_occupancy: null, past_avg_occupancy: 13 },
    '22:10': { today_occupancy: null, past_avg_occupancy: 12 },
    '22:20': { today_occupancy: null, past_avg_occupancy: 12 },
    '22:30': { today_occupancy: null, past_avg_occupancy: 13 },
    '22:40': { today_occupancy: null, past_avg_occupancy: 13 },
    '22:50': { today_occupancy: null, past_avg_occupancy: 11 },
    '23:00': { today_occupancy: null, past_avg_occupancy: 12 },
    '23:10': { today_occupancy: null, past_avg_occupancy: 9 },
    '23:20': { today_occupancy: null, past_avg_occupancy: 10 },
    '23:30': { today_occupancy: null, past_avg_occupancy: 10 },
    '23:40': { today_occupancy: null, past_avg_occupancy: 10 },
    '23:50': { today_occupancy: null, past_avg_occupancy: 9 },
};

const sparseSeries: OccupancySeries = [
    { time: '06:00', today: null, pastAvg: null },
    { time: '07:00', today: null, pastAvg: null },
    { time: '08:00', today: 12, pastAvg: 8 },
    { time: '09:00', today: null, pastAvg: 11 },
    { time: '10:00', today: 29, pastAvg: 25 },
    { time: '11:00', today: null, pastAvg: 34 },
    { time: '12:00', today: 41, pastAvg: 44 },
    { time: '13:00', today: null, pastAvg: 52 },
    { time: '14:00', today: 39, pastAvg: 49 },
    { time: '15:00', today: 34, pastAvg: null },
    { time: '16:00', today: null, pastAvg: 36 },
    { time: '17:00', today: 24, pastAvg: 30 },
    { time: '18:00', today: null, pastAvg: 24 },
    { time: '19:00', today: 13, pastAvg: 17 },
    { time: '20:00', today: null, pastAvg: 11 },
    { time: '21:00', today: 7, pastAvg: null },
    { time: '22:00', today: null, pastAvg: null },
];

const emptySeries: OccupancySeries = [
    { time: '06:00', today: null, pastAvg: null },
    { time: '07:00', today: null, pastAvg: null },
    { time: '08:00', today: null, pastAvg: null },
    { time: '09:00', today: null, pastAvg: null },
    { time: '10:00', today: null, pastAvg: null },
    { time: '11:00', today: null, pastAvg: null },
    { time: '12:00', today: null, pastAvg: null },
    { time: '13:00', today: null, pastAvg: null },
    { time: '14:00', today: null, pastAvg: null },
    { time: '15:00', today: null, pastAvg: null },
    { time: '16:00', today: null, pastAvg: null },
    { time: '17:00', today: null, pastAvg: null },
    { time: '18:00', today: null, pastAvg: null },
    { time: '19:00', today: null, pastAvg: null },
    { time: '20:00', today: null, pastAvg: null },
    { time: '21:00', today: null, pastAvg: null },
    { time: '22:00', today: null, pastAvg: null },
];

type MockComparePeriod = '4w' | '3m' | '6m' | '12m';

const salesCallBaseSeries: OccupancySeries = [
    { time: '06:00', today: 34, pastAvg: 30 },
    { time: '07:00', today: 36, pastAvg: 32 },
    { time: '08:00', today: 39, pastAvg: 35 },
    { time: '09:00', today: 43, pastAvg: 38 },
    { time: '10:00', today: 47, pastAvg: 42 },
    { time: '11:00', today: 50, pastAvg: 45 },
    { time: '12:00', today: 53, pastAvg: 48 },
    { time: '13:00', today: 55, pastAvg: 50 },
    { time: '14:00', today: 57, pastAvg: 51 },
    { time: '15:00', today: 56, pastAvg: 51 },
    { time: '16:00', today: 52, pastAvg: 48 },
    { time: '17:00', today: 49, pastAvg: 45 },
    { time: '18:00', today: null, pastAvg: 41 },
    { time: '19:00', today: null, pastAvg: 37 },
    { time: '20:00', today: null, pastAvg: 34 },
    { time: '21:00', today: null, pastAvg: 31 },
    { time: '22:00', today: null, pastAvg: 29 },
];

function adjustPastAverage(series: OccupancySeries, reduction: number): OccupancySeries {
    return series.map((point) => ({
        ...point,
        pastAvg: point.pastAvg === null ? null : Math.max(0, point.pastAvg - reduction),
    }));
}

function buildSalesCallReport(reduction: number, averagePastPeak: number): HistoricalOccupancy {
    return {
        datapoints: buildDatapoints(adjustPastAverage(salesCallBaseSeries, reduction)),
        today_peak: 57,
        average_past_peak: averagePastPeak,
        current_occupancy: 49,
    };
}

export const mockHistoricalOccupancyByComparePeriod: Record<MockComparePeriod, HistoricalOccupancy> = {
    '4w': buildSalesCallReport(0, 52),
    '3m': buildSalesCallReport(2, 50),
    '6m': buildSalesCallReport(5, 47),
    '12m': buildSalesCallReport(8, 44),
};

export function getMockHistoricalOccupancy(comparePeriod: MockComparePeriod): HistoricalOccupancy {
    return mockHistoricalOccupancyByComparePeriod[comparePeriod] ?? mockHistoricalOccupancyByComparePeriod['12m'];
}

export const mockHistoricalOccupancyFull: HistoricalOccupancy = {
    datapoints: fullDatapoints,
    today_peak: 126,
    average_past_peak: 119,
    current_occupancy: 126,
};

export const mockHistoricalOccupancySparse: HistoricalOccupancy = {
    datapoints: buildDatapoints(sparseSeries),
    today_peak: 41,
    average_past_peak: 52,
    current_occupancy: 24,
};

export const mockHistoricalOccupancyEmpty: HistoricalOccupancy = {
    datapoints: buildDatapoints(emptySeries),
    today_peak: 0,
    average_past_peak: 0,
    current_occupancy: 0,
};
